module.exports = __webpack_public_path__ + "img/gb-nir.c5f074da.svg";